// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const throh: PokeData = {
  "id": 538,
  "name": "throh",
  "height": 13,
  "weight": 555,
  "base_experience": 163,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "bind",
    "body-slam",
    "leer",
    "seismic-toss",
    "focus-energy",
    "bide",
    "reversal",
    "endure",
    "vital-throw",
    "superpower",
    "revenge",
    "bulk-up",
    "wide-guard",
    "storm-throw",
    "circle-throw",
    "mat-block"
  ],
  "moves": [
    "body-slam",
    "leer",
    "seismic-toss",
    "superpower",
    "bulk-up",
    "karate-chop",
    "jump-kick",
    "double-kick",
    "rolling-kick",
    "close-combat",
    "coaching",
    "vacuum-wave",
    "meteor-assault"
  ],
  "evolution_chain": {
    "id": 274,
    "item": null,
    "species": [
      {
        "name": "throh",
        "order": 539,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 166,
    "speed": 73,
    "ability_power": 162
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
